import { ReactNode, useState } from "react";
import { Collapse } from "reactstrap";

interface Props {
  className?: string;
  title: ReactNode;
  children?: ReactNode; // When passed, the component functions as a "Collapse" as well.
  openIcon?: string;
  icon: `mdi mdi-${string}` | JSX.Element;
  onClick?: () => void;
  rowClassName?: string;
  options?: ReactNode;
}

export default function AppItemCard({
  children,
  title,
  className,
  rowClassName,
  onClick,
  openIcon,
  icon,
  options,
}: Props) {
  const [open, setOpen] = useState(false);

  const handleOnClick = (e: any) => {
    if (e.currentTarget != e.target) return;

    onClick && onClick();
    children && setOpen((prev) => !prev);
  };

  return (
    <>
      <div
        onClick={children || onClick ? handleOnClick : undefined}
        className={`d-flex cursor-pointer my-0 py-2 px-2 border-bottom border-superlight bg-dropdown-hover--hover  ${
          rowClassName ? rowClassName : ""
        } justify-content-between`}
      >
        <div
          className="d-flex justify-content-between w-100"
          onClick={children || onClick ? handleOnClick : undefined}
        >
          <div className="d-flex align-items-center">
            {typeof icon === "string" ? (
              <i
                className={`${
                  open && openIcon ? openIcon : icon
                } pr-3 text-dark`}
                style={{ fontSize: 21 }}
                onClick={children || onClick ? handleOnClick : undefined}
              />
            ) : (
              icon
            )}
            {typeof title === "string" ? (
              <div
                className="text-dark font-weight-500"
                onClick={children || onClick ? handleOnClick : undefined}
              >
                {title}
              </div>
            ) : (
              title
            )}
          </div>
          <div className="d-flex">{options}</div>
        </div>
      </div>
      {children && <Collapse isOpen={open}>{children}</Collapse>}
    </>
  );
}
